import RootLayout from './layout/rootLayout.vue'
import CandidateRoute from './candidate/route'
import JobListRoute from './jobList/route'
import ApplicantListRoute from './applicantList/route'
import resetPasswordRoute from './resetPassword/route'

const basePath = '/v-agency'

export default {
  path: `${basePath}`,
  component: RootLayout,
  meta: {
    isRootLayout: true
  },
  children: [
    CandidateRoute,
    JobListRoute,
    ApplicantListRoute,
    resetPasswordRoute
  ]
}
